import React from "react"

import {
  cn,
  parseIframeUrl,
  resolveButtonHref,
  transformButtonStyle,
} from "@/lib/utils"
import { Link, TButton, Typography } from "@/components/ui/atoms"

interface IChecklistSubscriptionProps {
  title: string
  description: string
  iframe: string
  button?: TButton
  isInList?: boolean
  isLast?: boolean
  isInArticle?: boolean
}

const ChecklistSubscription = React.forwardRef<
  HTMLDivElement,
  IChecklistSubscriptionProps
>(
  (
    {
      title,
      iframe,
      description,
      button,
      isInList = false,
      isLast = false,
      isInArticle = false,
      ...props
    },
    ref
  ) => {
    return (
      <div
        className={cn(
          "bg-secondary-400",
          isInArticle ? "rounded-100" : "",
          isLast && isInList ? "min-w-[calc(50%-12px)]" : ""
        )}
        ref={ref}
        {...props}
      >
        <div
          className={cn(
            " flex flex-col gap-6",
            isInList
              ? "items-center text-center lg:py-9"
              : " container items-start py-9"
          )}
        >
          <Typography as="h2" variant="headingM">
            {title}
          </Typography>
          <Typography as="p" variant="paragraphM">
            {description}
          </Typography>
          <iframe
            className="min-w-[75%]"
            height={parseIframeUrl(iframe).height}
            src={parseIframeUrl(iframe).url}
            title="Formulaire d'inscription à la newsletter"
          ></iframe>
          {button ? (
            <div>
              <Link
                chapters={[title, button.ctaLabel]}
                key={button.ctaLink}
                variant={transformButtonStyle(button.style)}
                iconLeft={button.iconLeft ?? undefined}
                iconRight={button.iconRight ?? undefined}
                href={resolveButtonHref(button)}
              >
                {button.ctaLabel}
              </Link>
            </div>
          ) : null}
        </div>
      </div>
    )
  }
)
ChecklistSubscription.displayName = "ChecklistSubscription"

export { ChecklistSubscription, type IChecklistSubscriptionProps }
